export default __webpack_public_path__ + "static/media/authBottom.1e795c2b.png";